import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Reveal } from './Section';
type Review = {
  initials: string;
  name: string;
  detail: string;
  quote: string;
};
const reviews: Review[] = [{
  initials: 'SM',
  name: 'Sebastián M.',
  detail: 'Buenos Aires · Empezando desde cero',
  quote: 'Entendí una forma de empezar en una tarde. Practiqué los días recomendados y después pude mirar mis decisiones con mucha más claridad.'
}, {
  initials: 'CR',
  name: 'Claudia R.',
  detail: 'Rosario · Principiante',
  quote: 'Los tips para arrancar me cambiaron la forma de mirar mi plata. Por fin siento que sé qué preguntas hacer antes de decidir.'
}, {
  initials: 'DP',
  name: 'Diego P.',
  detail: 'Córdoba · Empezando a invertir',
  quote: 'La idea de “Primero cuidar lo que tenés” es única. Ahora pienso más en cuidar mi plata y no solo en querer ganar rápido.'
}];
function GoldStars() {
  return <div className="mt-5 flex gap-1" aria-label="5 de 5 estrellas" data-id="element-205" data-mp="14smej0p8ptlk">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-206" data-mp="1yps7nni27qoj" data-mpi={index} />)}
    </div>;
}
export function SocialProofReviews() {
  return <section className="w-full bg-ink-950 px-5 py-14 sm:py-16" data-id="element-207" data-mp="1k2p7f92cr3xi">
      <div className="mx-auto w-full max-w-4xl" data-id="element-208" data-mp="1ozfr06dd8hno">
        <Reveal data-id="element-209" data-mp="1oy4n86jx79wk">
          <div className="text-center" data-id="element-210" data-mp="2cptinvs1gehq">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-211" data-mp="2cquwu94cph3o">Experiencias reales</p>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl" data-id="element-212" data-mp="2hnl7ui1atmi8">
              Claridad para empezar con método
            </h2>
          </div>
        </Reveal>

        <div className="mt-8 grid gap-4 lg:grid-cols-3" data-id="element-213" data-mp="27pfdqmlqhknx">
          {reviews.map((review, index) => <Reveal key={review.initials} delay={index * 0.08} data-id="element-214" data-mp="rax9drq2oaho" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-brand/35 bg-black p-5 sm:p-6" data-id="element-215" data-mp="wbtn0x087b0a">
                <div className="flex items-center gap-3" data-id="element-216" data-mp="2yx71e2dpjccw">
                  <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full border border-brand/40 bg-brand-soft font-display text-sm font-bold text-brand" data-id="element-217" data-mp="2tz5jvlvxjl3j">
                    {review.initials}
                  </span>
                  <div className="min-w-0" data-id="element-218" data-mp="2k8aui8ne05dv">
                    <figcaption className="font-display text-sm font-bold text-white" data-id="element-219" data-mp="2k7hx3yabis8e">{review.name}</figcaption>
                    <p className="mt-1 flex items-start gap-1 text-xs leading-snug text-gray-500" data-id="element-220" data-mp="2b8nxdz1oxlqm">
                      <MapPinIcon className="mt-px h-3.5 w-3.5 flex-none" data-id="element-221" data-mp="269jiqsvzyvsw" />
                      <span data-id="element-222" data-mp="26bnq5kt3ucxx">{review.detail}</span>
                    </p>
                  </div>
                </div>
                <blockquote className="mt-5 text-sm leading-relaxed text-gray-300" data-id="element-223" data-mp="4i6hcdt8n61l">“{review.quote}”</blockquote>
                <div className="mt-auto" data-id="element-224" data-mp="3vor6tt3na5wi"><GoldStars data-id="element-225" data-mp="3vpj0uzhlfvko" /></div>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}